<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold">Thêm mới người dùng</p>
            </div>
            <button @click="saveAction" class="admin-save-btn">
                <i class='bx bx-save text-white my-auto' ></i><p>Lưu</p>
            </button>
        </div>
        <div class="entry-detail row gap-2">
            <div class="row col-12 col-md-8 pr-0 pr-md-2 gap-2">
                <entryName class="col-12 !pr-0" v-model="entry" @update="(e) => (entry = e)" />
                <entryEmail class="col-12 !pr-0" v-model="entry" @update="(e) => (entry = e)" />
                <entryPhone class="col-12 !pr-0" v-model="entry" @update="(e) => (entry = e)" />
                <entryPassword class="col-12 !pr-0" v-model="entry" @update="(e) => (entry = e)" />
            </div>
            <entryImage class="col-12 col-md-4" v-model="entry" @update="(e) => (entry = e)" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import entryName from './partials/entry-name.vue';
import entryEmail from './partials/entry-email.vue';
import entryImage from './partials/entry-image.vue';
import entryPhone from './partials/entry-phone.vue';
import entryPassword from './partials/entry-password.vue';
export default {
    name: 'create',
    components: {
        entryPhone, entryName, entryEmail, entryImage, entryPassword
    },
    data() {
        return {
            entry: {
                name: '',
                phone: '',
                email: '',
                image: '',
                password: '',
            }
        }
    },
    methods: {
        ...mapActions('user', ['CreateUser']),
        saveAction() {
            let validate = {
                name: 'Tên người dùng',
                email: 'Email',
                phone: 'Số điện thoại',
                password: 'Mật khẩu',
                image: 'Hình ảnh',
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Thêm mới người dùng?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Thêm!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await this.CreateUser(this.entry);
                    this.goBack()
                }
            })
        },
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        }
    }
}
</script>
<style>
.entry-detail .form-group {
    margin-bottom: 0;
}
</style>